import Http from '../../common/services/Http';
import CustomFile from 'common/models/CustomFile';
import { ChargeImportRowValidationResult, ImportChargeProcessFileViewModel, ImportChargeViewModel } from './models/ImportChargeViewModel';
import { Paged } from 'api/common/types/Page';
import { ImportExpenseFileDto, ImportExpenseFileIdDto, ImportExpenseFileItemDto } from './models/ImportExpenseFileDto';
import { ImportExpenseFilesSearchCriteria } from './models/ImportExpenseFilesSearchCriteria';
import { ImportExpenseFileItemsSearchCriteria } from './models/ImportExpenseFileItemsSearchCriteria';

class ImportChargeService {
    
    public import(model: ImportChargeViewModel, attachment: CustomFile) {
        return Http.postWithFile<string>('importCharge', model, [attachment]);
    }

    public getList(criteria: ImportExpenseFilesSearchCriteria) {
        return Http.get<Paged<ImportExpenseFileDto>>('importCharge', criteria);
    }

     public getListItems(criteria: ImportExpenseFileItemsSearchCriteria) {
         return Http.get<Paged<ImportExpenseFileItemDto>>('importCharge/list-items', criteria);
     }

    public getById(id: string) {
        return Http.get<ImportExpenseFileDto>('importCharge/' + id);
    }

    public updateFileItem(model: ImportExpenseFileItemDto) {
        return Http.post('importCharge/change-file-item', model);
    }

    public process(model: ImportExpenseFileIdDto) {
        return Http.post<ImportChargeProcessFileViewModel>('importCharge/process-file', model);
    }

    public remove(model: ImportExpenseFileIdDto) {
        return Http.put('importCharge/deactivate', model);
    }  

    public importWizard(model: ImportChargeViewModel, attachments: CustomFile[]) {
        return Http.postWithFile<string>('importCharge/wizard', model, attachments);
    }

    // Task #66078: step-4 preview of import validation warnings (kms decrease, daily-km limit,
    // tank/battery capacity, duplicates). Read-only, does not persist anything.
    public validateRows(items: any[]) {
        return Http.post<ChargeImportRowValidationResult[]>('importCharge/validate-rows', { items });
    }
}

export default new ImportChargeService();